import { connect } from 'react-redux';
import { selectIsDeviceTypeDesktop } from 'selectors/device';
import Link from '@sp/ui/v2/base/Link';

const mapStateToProps = (state) => ({
  isDesktop: selectIsDeviceTypeDesktop(state),
});

export default connect(mapStateToProps)(Link);
